function intersectionArraysForDeletion(array1, array2) {
    // Transforma o array2 em um Set para busca eficiente
    const set2 = new Set(array2.map(obj => JSON.stringify(obj)));

    // Retorna apenas os objetos de array1 que estão no set2
    return array1.filter(obj => set2.has(JSON.stringify(obj)));
}

function intersectionArraysForAdd(array1, array2) {
    // Transforma o array1 em um Set para busca eficiente
    const set1 = new Set(array1.map(obj => JSON.stringify(obj)));

    // Retorna apenas os objetos de array2 que não estão no set1
    return array2.filter(obj => !set1.has(JSON.stringify(obj)));
}

export { intersectionArraysForDeletion, intersectionArraysForAdd };